import { Box, Button, Card, Tab, Tabs, TextField, Typography } from '@material-ui/core';
import React, { useEffect, useRef, useState } from 'react';
import './style.css';
import { useDataProvider } from 'ra-core';
import { useNotify, useRefresh } from 'react-admin';
import JoditEditor from 'jodit-react';

const LegalStaffTab = () => {
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();

  const editor = useRef(null);

  const [id, setId] = useState('');
  const [policy, setPolicy] = useState('');
  const [conditions, setConditions] = useState('');
  const [subscriptionTerms, setSubscriptionTerms] = useState('');
  const [subscriptionTermsVersion, setSubscriptionTermsVersion] = useState('');
  const [subscriptionTermsEffectiveDate, setSubscriptionTermsEffectiveDate] = useState('');
  const [activeDocument, setActiveDocument] = useState('conditions');

  const handleChangePolicy = (eOrHtml) => {
    // setPolicy(newContent);
    const newContent =
      typeof eOrHtml === 'string'
        ? eOrHtml
        : eOrHtml && eOrHtml.currentTarget && eOrHtml.currentTarget.innerHTML;

    if (newContent) {
      setPolicy(newContent);
    }
  };

  const handleChangeConditions = (eOrHtml) => {
    // setConditions(newContent);
    const newContent =
      typeof eOrHtml === 'string'
        ? eOrHtml
        : eOrHtml && eOrHtml.currentTarget && eOrHtml.currentTarget.innerHTML;

    if (newContent) {
      setConditions(newContent);
    }
  };

  const handleChangeSubscriptionTerms = (eOrHtml) => {
    const newContent =
      typeof eOrHtml === 'string'
        ? eOrHtml
        : eOrHtml && eOrHtml.currentTarget && eOrHtml.currentTarget.innerHTML;

    if (newContent) {
      setSubscriptionTerms(newContent);
    }
  };

  useEffect(() => {
    getGeneral();
  }, []);

  const getGeneral = async () => {
    const result = await dataProvider.getGeneral();
    const policy = result.data.policy ? result.data.policy : '';
    const conditions = result.data.conditions ? result.data.conditions : '';
    const subscriptionTerms = result.data.subscriptionTerms
      ? result.data.subscriptionTerms
      : '';
    setId(result.data._id);
    setPolicy(policy);
    setConditions(conditions);
    setSubscriptionTerms(subscriptionTerms);
    setSubscriptionTermsVersion(result.data.subscriptionTermsVersion || '');
    setSubscriptionTermsEffectiveDate(
      result.data.subscriptionTermsEffectiveDate
        ? String(result.data.subscriptionTermsEffectiveDate).slice(0, 10)
        : '',
    );
  };
  const handleSave = async () => {
    const result = await dataProvider.updateGeneral({
      id: id,
      data: { conditions: conditions },
      previousData: {} as any,
    });
    if (!result.data) {
      notify('something went wrong', 'error');
    }
    notify(`Successfully update`);
    refresh();
  };

  const handleSaveSubscriptionTerms = async () => {
    const result = await dataProvider.updateGeneral({
      id: id,
      data: {
        subscriptionTerms: subscriptionTerms,
        subscriptionTermsVersion: subscriptionTermsVersion,
        subscriptionTermsEffectiveDate: subscriptionTermsEffectiveDate,
      },
      previousData: {} as any,
    });
    if (!result.data) {
      notify('something went wrong', 'error');
    }
    notify(`Successfully update`);
    refresh();
  };

  const handleSavePrivacy = async () => {
    const result = await dataProvider.updateGeneral({
      id: id,
      data: { policy: policy },
      previousData: {} as any,
    });
    if (!result.data) {
      notify('something went wrong', 'error');
    }
    notify(`Successfully update`);
    refresh();
  };

  const documents = [
    {
      id: 'conditions',
      title: 'Terms & Conditions',
      value: conditions,
      onBlur: handleChangeConditions,
      onSave: handleSave,
    },
    {
      id: 'subscriptionTerms',
      title: 'Subscription Terms',
      value: subscriptionTerms,
      onBlur: handleChangeSubscriptionTerms,
      onSave: handleSaveSubscriptionTerms,
    },
    {
      id: 'policy',
      title: 'Privacy Policy',
      value: policy,
      onBlur: handleChangePolicy,
      onSave: handleSavePrivacy,
    },
  ];
  const active = documents.find((document) => document.id === activeDocument) || documents[0];

  return (
    <Card component='div' className='privacy-wrapper'>
      <Tabs
        value={active.id}
        onChange={(_event, value) => setActiveDocument(value)}
        indicatorColor='primary'
        textColor='primary'
        variant='fullWidth'
      >
        {documents.map((document) => (
          <Tab key={document.id} value={document.id} label={document.title} />
        ))}
      </Tabs>
      <Box marginTop={2}>
        <Box marginBottom={0.5}>
          <Typography variant='h5'>{active.title}</Typography>
        </Box>
        {active.id === 'subscriptionTerms' ? (
          <Box display='flex' marginBottom={2}>
            <Box marginRight={2}>
              <TextField
                label='Version'
                value={subscriptionTermsVersion}
                onChange={(event) => setSubscriptionTermsVersion(event.target.value)}
                variant='outlined'
                size='small'
              />
            </Box>
            <TextField
              label='Effective date'
              type='date'
              value={subscriptionTermsEffectiveDate}
              onChange={(event) => setSubscriptionTermsEffectiveDate(event.target.value)}
              variant='outlined'
              size='small'
              InputLabelProps={{ shrink: true }}
            />
          </Box>
        ) : null}
        <div className='privacy-text-area-form'>
          <div className='privacy-text-area'>
            <JoditEditor
              key={active.id}
              ref={editor}
              value={active.value}
              onBlur={(newContent) => active.onBlur(newContent)}
              onChange={() => {}}
            />
          </div>
        </div>
      </Box>
      <Box padding='1rem'>
        <Button
          variant='contained'
          color='primary'
          disableElevation
          onClick={active.onSave}
        >
          Save
        </Button>
      </Box>
    </Card>
  );
};
export default LegalStaffTab;
